export enum PepRelationship {
  SIGNATORY = 'signatory',
  SPOUSE = 'spouse',
  FAMILY_MEMBER = 'family_member',
  BUSINESS_ASSOCIATE = 'business_associate',
  CEO = 'ceo'
}

export enum PepPublicRole {
  HEAD_OF_STATE = 'head_of_state',
  MAYOR = 'mayor',
  JUDGE = 'judge',
  PARLIAMENT_MEMBER = 'parliament_member',
  SENIOR_PARTY_MEMBER = 'senior_party_member',
  GOVERNMENT_MEMBER = 'government_member',
  SENIOR_MILITARY_OR_POLICE_OFFICER = 'senior_military_or_police_officer',
  SENIOR_STATE_COMPANY_OFFICIAL = 'senior_state_company_official',
  SENIOR_INTERNATIONAL_ORG_OFFICIAL = 'senior_international_org_official',
  OTHER = 'other'
}
